/**
 *
 *  * Всего total
 * Выдано given
 * Свободно free
 * Списано decommissioned
 * Просрочено expired
 * общая стоимость cost
 */

export function StatsModel() {
    const totalData = {
        total: "0",
        issued: "0",
        free: "0",
        writtenOff: "0",
        expired: "0",
        cost: "0",
    };

    const filteredData = {
        total: "0",
        issued: "0",
        free: "0",
        writtenOff: "0",
        expired: "0",
        cost: "0",
    };

    function setData(stats, newData = {}) {
        stats.total = parseInt(newData.total || 0, 10);
        stats.issued = parseInt(newData.given || 0, 10);
        stats.free = parseInt(newData.free || 0, 10);
        stats.writtenOff = parseInt(newData.decommissioned || 0, 10);
        stats.expired = parseInt(newData.expired || 0, 10);
        stats.cost = parseInt(newData.cost || 0, 10);
    }

    function update(data) {
        const { all, filtered } = data;
        setData(totalData, all);
        setData(filteredData, filtered);
    }

    function reset() {
        setData(totalData);
        setData(filteredData);
    }

    return {
        totalData,
        filteredData,

        update,
        reset,
    };
}
